import React from 'react';

import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { AdminControls } from '@confluence/team-admin-controls/entry-points/AdminControls.ts';

export const AdminTeamControlsRoute = () => <AdminControls />;

AdminTeamControlsRoute.NAVIGATION_PARAMS = () => ({
	Screen: {
		screenEvent: { name: 'adminTeamControlsSettings' },
	},
	sideNavigationId: ADMIN_HOME_ID,
	analyticsSource: 'adminTeamControlsSettings',
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
